export default "__VITE_ASSET__BHnW_w1y__"